import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { getAllEmployees, addEmployee } from '../actions';
import RestaurantSelector from './RestaurantSelector';
import EmployeeList from './EmployeeList';

const Employee = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const employees = useSelector(state => state.employees)
    const [restaurantId, setRestaurantId] = useState(1)
    const [employeeName, setEmployeeName] = useState('')
    useEffect(() => {
        dispatch(getAllEmployees(restaurantId))
      }, [dispatch, restaurantId]);
    const changeReportRestaurant = restaurantId => {
        setRestaurantId(restaurantId)
        dispatch(getAllEmployees(restaurantId))
    }
    return (
        <div className="container">
            <h1>Employee Management</h1>
            <button onClick={() => {
                navigate("/");
            }}>Back to Daily Records</button>
            <p/>
            <RestaurantSelector restaurantId={restaurantId} handleChangeRestaurant={changeReportRestaurant}/>
            <p/>
            <input type="text" name="employeeName" style={{width: '100px'}} value={employeeName} onChange={e => setEmployeeName(e.target.value)} />
            <button onClick={() => {if (employeeName !== "") {
                dispatch(addEmployee(restaurantId, employeeName))
                setEmployeeName("")} else {
                    alert("Please input the name of the employee.")
                }
            }}>Add Employee</button>
            <p/>
            <EmployeeList employees={employees} />
        </div>
    )
}

export default Employee